import type { FlexContainerDateProps } from "./flex-container-date.type";

import { format } from "@/utilities/date";

import { FlexContainerText } from "../flex-container-text";

const FlexContainerDate = ({
  value,
  dateFormat,
  ...containerProps
}: FlexContainerDateProps) => {
  return (
    <FlexContainerText {...containerProps} value={format(value, dateFormat)} />
  );
};

export default FlexContainerDate;
